export function getDateInEst(date?: Date): Date {
    const now = date || new Date();
    return new Date(now.toLocaleString("en-US", {timeZone: "America/New_York"}));
}